import { WrappedFieldProps } from 'redux-form';

import { QueueSelect } from './queueSelect';

type ComposeEmailModalQueueSelectProps = WrappedFieldProps;

export const QueueSelectField = (props: ComposeEmailModalQueueSelectProps) => {
  const { input } = props;
  return <QueueSelect selectedQueue={input.value} onSelect={input.onChange} />;
};
